import React from "react";
import TableUsers from "../../components/TableUsers";
import HeaderApp from "../../components/HeaderApp";

const ManageUsers = () => {
  
  return (
    <>
      <HeaderApp/>
      <TableUsers/>
    </>
  );
};

export default ManageUsers;
